@if (controlOnly) {
  <app-input-reusable
    [label]="label"
    [placeholder]="placeholder"
    type="text"
    [size]="size"
    [control]="externalPostcodeControl"
    [required]="required"
    textCase="uppercase"
    [externalErrorMessage]="externalErrorMessage"
    (focusout)="markAsTouched()"
  ></app-input-reusable>
} @else {
  <section class="w-full">
    <form [formGroup]="form" class="space-y-4">
      <div [class]="fieldGridClass">
        @if (showPostcodeField) {
        <div>
          <app-input-reusable
            [label]="label"
            [required]="true"
            [placeholder]="placeholder"
            type="text"
            [size]="size"
            [control]="form.controls.postcode"
            textCase="uppercase"
          ></app-input-reusable>

          <p class="mt-1 text-xs text-slate500" *ngIf="showLookupFeedback && isLoading">Looking up addresses...</p>
          <p class="mt-1 text-xs text-red600" *ngIf="showLookupFeedback && lookupError">{{ lookupError }}</p>
        </div>
        }

        @if (showAddressField) {
        <div>
          @if (useAddressDropdown) {
            <app-select
              [form]="form"
              [label]="addressLabel"
              controlName="address"
              [size]="size"
               [required]="true"
              [options]="availableAddresses"
              [placeholder]="isLoading ? 'Loading address...' : addressPlaceholder"
              [disabled]="availableAddresses.length === 0 || isLoading"
            ></app-select>
          } @else {
            <app-input-reusable
              [label]="addressLabel"
              [placeholder]="isLoading ? 'Loading address...' : addressPlaceholder"
              type="text"
              [size]="size"
              [control]="form.controls.address"
              [disabled]="isLoading"
               [required]="true"
            ></app-input-reusable>
          }
        </div>
        }

        @if (showCityField) {
        <app-input-reusable
          [label]="cityLabel"
          [placeholder]="isLoading ? 'Loading city...' : cityPlaceholder"
          type="text"
          [size]="size"
          [control]="form.controls.city"
          [disabled]="isLoading"
           [required]="true"
        ></app-input-reusable>
        }

        @if (showCountryField) {
        @if (countryOptions.length > 0) {
          <app-select
            [form]="form"
            [label]="countryLabel"
            controlName="country"
            [size]="size"
            [options]="countryOptions"
            [placeholder]="isLoading ? 'Loading country...' : countryPlaceholder"
            [disabled]="isLoading"
             [required]="true"
          ></app-select>
        } @else {
          <app-input-reusable
            [label]="countryLabel"
            [placeholder]="isLoading ? 'Loading country...' : countryPlaceholder"
            type="text"
            [size]="size"
            [control]="form.controls.country"
             [required]="true"
            [disabled]="isLoading"
          ></app-input-reusable>
        }
        }
      </div>
    </form>
  </section>
}
